<template>
  <component
    :is="tag"
    class="baseButton"
    :class="[
      type ? `baseButton--${type}` : false,
      {'baseButton--disabled': disabled },
    ]"
    :href="href || false"
    @click.stop="onClick"
  >
    {{ text }}
  </component>
</template>

<script>
export default {
  name: 'BaseButton',
  props: {
    text: {
      type: String,
      default: 'OK',
    },
    disabled: {
      type: Boolean,
      default: false
    },
    type: String,
    href: String,
  },
  computed: {
    tag() {
      return this.href ? 'a' : 'div'
    }
  },
  methods: {
    onClick(e){
      if(!this.disabled) this.$emit('click')
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../../../../sass/commons/commonVariables.scss';

.baseButton {
  display: block;
  width: 100%;
  margin: auto;
  border: 1px solid #9081C8;
  box-sizing: border-box;
  border-radius: 100px;
  font-weight: bold;
  font-size: 16px;
  line-height: 19px;
  text-align: center;
  color: #9081C8;
  text-decoration: none;
  background: #fff;
  height: 48px;
  line-height: 48px;
  max-width: 287px;
  cursor: pointer;
  transition: 0.2s;
  &:hover {
    background: rgba(255, 255, 255, 0.75);
  }
  &:disabled,
  &--disabled {
    pointer-events: none;
    border-color: #D8D8D8;
    color: #D8D8D8;
  }
  // type = fill
  &--fill {
    color: #fff;
    background: $academy_purple3;
    border: none;
    &:hover {
      background: rgba($academy_purple3, 0.75);
    }
  }
}
</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/Ulmar/partials/BaseButton.vue